/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

// libraries
import React from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import { object } from 'prop-types';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import { Query } from 'react-apollo';
import mbpLogger from 'mbp-logger';
import loadable from '@loadable/component';

// helpers
import { GRAPHQL_ENV } from '../../../../gql';
import { getLanguageName, setLocale } from '../../../../../state/ducks/Member/ducks/Auth/helper/helper';
import { getDataDictionary } from '../../../../../state/ducks/App/App-Selectors';

// query
import findContent from '../../../../gql/queries/findContent';
import * as app from '../../../../../state/ducks/App';

// components
const CustomerServiceModifyOrderPlants = loadable(() => import(/* webpackChunkName: "CustomerServiceModifyOrderPlants" */ './CustomerServiceModifyOrderPlants'));
const CustomerServiceModifyOrder = loadable(() => import(/* webpackChunkName: "CustomerServiceModifyOrder" */ './CustomerServiceModifyOrder'));

const brandSelectors = app?.ducks?.brand?.selectors;

const styles = () => ({
    h1: {
        display: 'block',
    },
    modifyOrderContainer: {
        margin: '0px auto 80px auto',
        maxWidth: '1400px',
    },
});
const GraphqlCustomerServiceModifyOrder = ({ classes, brand, dataDictionary }) => {
    const selectedLanguage = getLanguageName();
    const findContentOptions = {
        brand: brand.domain,
        environment: `${GRAPHQL_ENV}`,
        locale: setLocale() || 'en-us',
        contentType: 'template_page_modify_order',
    };
    const FIND_CONTENT_QUERY = findContent(findContentOptions);
    return (
        <Query query={FIND_CONTENT_QUERY}>
            {({ loading, error, data }) => {
                if (loading) {
                    return null;
                }
                if (error) {
                    mbpLogger.logError({
                        query: FIND_CONTENT_QUERY,
                        component: 'GraphqlCustomerServiceModifyOrder.js',
                        message: 'Error loading data from Graphql',
                        env: GRAPHQL_ENV,
                        error,
                    });
                }
                let customerServiceData = null;
                if (data?.findContent?.content !== null) {
                    if (data?.findContent?.content?.entries?.length > 0) {
                        customerServiceData = data?.findContent?.content?.entries?.[0];
                    }
                }
                return (
                    <div className={classes.modifyOrderContainer}>
                        <div className={classes.modifyOrderInner}>
                            {
                                brand.code === 'PLA'
                                    ? (
                                        <CustomerServiceModifyOrderPlants
                                            block={customerServiceData}
                                            dataDictionary={dataDictionary}
                                            language={selectedLanguage}
                                        />
                                    )
                                    : (
                                        <CustomerServiceModifyOrder
                                            block={customerServiceData}
                                            dataDictionary={dataDictionary}
                                            language={selectedLanguage}
                                        />
                                    )
                            }
                        </div>
                    </div>
                );
            }}
        </Query>
    );
};

const mapStateToProps = (state) => ({
    brand: brandSelectors.getBrand(state),
    dataDictionary: getDataDictionary(state),
});

const enhance = compose(
    withStyles(styles),
    connect(mapStateToProps),
);

GraphqlCustomerServiceModifyOrder.propTypes = {
    classes: object.isRequired,
    brand: object.isRequired,
    dataDictionary: object.isRequired,
};

export default enhance(GraphqlCustomerServiceModifyOrder);
